import styled, { css } from 'styled-components'

import { themeStyles } from '../../../styles/theme'

// The remainder is used to see if there are less slides shown than what needs to be shown
// (e.g. 10 slides, and we need to show 4 each time, meaning on the last segment, there will only be 2 slides)
const calculateTransformPosition = ({
  gap,
  length,
  index,
  maxItemsVisible,
}) => {
  if (length < maxItemsVisible) return ''
  const remainder = length - maxItemsVisible * index
  const slideWidth = (100 / length) * maxItemsVisible
  const gapWidth = gap / (length / maxItemsVisible)
  if (remainder < maxItemsVisible)
    index -= (maxItemsVisible - remainder) / maxItemsVisible

  return css`
    transform: translate3d(
      calc(calc(${slideWidth}% + ${gapWidth}em) * ${-index}),
      0,
      0
    );
  `
}

export const StyledCarouselWrapper = styled.div`
  width: 100%;
  position: relative;
`

export const StyledSlidesWrapper = styled.div`
  position: relative;
  display: flex;
  gap: ${({ gap }) => gap}em;
  overflow: hidden;

  width: calc(
    ${(props) => (100 / props.maxItemsVisible) * props.length}% +
      ${({ gap, length, maxItemsVisible }) =>
        gap * (length / maxItemsVisible - 1)}em
  );
  transition-duration: 500ms;
  ${calculateTransformPosition}
  overflow: hidden;

  > * {
    padding: 0;
    width: 100%;
    overflow: hidden;
    position: relative;
    ${(props) =>
      !props.hideHoverBorder &&
      css`
        border-radius: 8px;
        background: transparent;
        border: 2px solid transparent;
        transition: 0.2s border;

        &:hover {
          border: 2px solid ${themeStyles.colors.white.main}4D;
        }
      `}
  }
`

export const StyledHideOverflow = styled.div`
  overflow: hidden;
`
